import { __assign } from "tslib";
// DS: I08
import React, { useRef } from 'react';
import IconWrap from '../../IconWrap';
var instances = 0;
var ChangeBg = function (props) {
    var instanceId = useRef(instances++);
    var gradientId = "icon-i08-" + instanceId.current + "-a";
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("defs", null,
                React.createElement("linearGradient", { id: gradientId, x1: "10.264%", x2: "91.383%", y1: "9.695%", y2: "91.6%" },
                    React.createElement("stop", { offset: "0%", stopColor: "#FCF53C" }),
                    React.createElement("stop", { offset: "43.255%", stopColor: "#FF5DD3" }),
                    React.createElement("stop", { offset: "64.162%", stopColor: "#078BFB" }),
                    React.createElement("stop", { offset: "100%", stopColor: "#06D290" }))),
            React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(2 3)" },
                React.createElement("rect", { width: "18", height: "18", x: "1", fill: "url(#" + gradientId + ")", rx: "1" }),
                React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M19 0a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h18zm-1 2H2v14h16V2z" })))));
};
ChangeBg.displayName = 'ChangeBg';
export default ChangeBg;
//# sourceMappingURL=ChangeBg.js.map